import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {NgIf} from "@angular/common";
import { Dimensions, ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';
import { DomSanitizer, SafeResourceUrl  } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import {DocumentsService} from "../../../../services/document.service";
import {
    equiposEjercicios, mecanicasEjercicios,
    musculosEjercicios,
    nivelesEjercicios, tiposEjercicios,
} from 'src/app/models/ejercicio.model';
import { ClaseModel, tiposClases } from 'src/app/models/clase.model';
import {environment} from "../../../../../environments/environment";
import { UtilsService } from 'src/app/services/utils.service';
import { UploadService } from 'src/app/services/upload.service';
declare var $: any;

@Component({
  selector: 'app-clases',
  standalone: true,
    imports: [
        NgIf,
        ReactiveFormsModule,
        CommonModule,
        FormsModule, 
        ImageCropperModule
    ],
  templateUrl: './clases.component.html',
  styleUrl: './clases.component.css'
})
export class ClasesComponent {
    @Input({required: true}) userInfo: any;
    pattern = 'clase'

    formClase: FormGroup;
    listaClases: ClaseModel[] = [];
    listaClasesFiltradas: ClaseModel[] = [];
    submitFormClases: boolean = false;
    editarClase: any = false;

    // Filtros
    tiposClases = tiposClases;
    musculosEjercicios = musculosEjercicios;
    nivelesEjercicios = nivelesEjercicios;
    equiposEjercicios = equiposEjercicios;
    filtroPropietario = 'todos'

    // Clases
    tiposClasesCl = tiposClases;
    musculosEjerciciosCl = musculosEjercicios;
    nivelesEjerciciosCl = nivelesEjercicios;
    equiposEjerciciosCl = equiposEjercicios;

    filtroTipo = '';
    filtroNivel = '';
    filtroNombreTemp: string = '';

    arrTags: any = []
    arrTagsSearch: any = [];
    arrTagsFilter: any = [];

    constructor(private fb: FormBuilder,
                private documentService: DocumentsService,
                private sanitizer: DomSanitizer,
                private utilsService: UtilsService,
                private uploadService: UploadService) {
        this.formClase = this.fb.group
        ({
            nombre: ['', [Validators.required]],
            tipo: [''],
            nivel: [''],
            duracion: ['', [Validators.required]],
            equipo: [''],
            musculo1: [''],
            musculo2: [''],
            musculo3: [''],

            descripcion: [''],
            linkVideo: [''],
            linkAdicional1: [''],
            linkAdicional2: [''],
            linkAdicional3: [''],
        })
    }

    ngOnInit(): void {
        this.getClases();
    }

    @Output() messageEvent = new EventEmitter<string>();
    sendClseSelected(clase) {
        this.messageEvent.emit(clase);
    }
    
    /**************************************************/
    /************ AGREGAR/EDITAR CLASES *************/
    modalClase()
    {
        $('#modal-clase').modal({backdrop: 'static', keyboard: false})
        $("#modal-clase").modal('show');
    }
    modalEditarClase(clase)
    {
      this.editarClase = clase;
      this.formClase.patchValue({
        nombre: clase.nombre,
  
        tipo: clase.tipo,
        nivel: clase.nivel,
        duracion: clase.duracion,
        equipo: clase.equipo,
        // musculo: ejercicio.musculo,
  
        descripcion: clase.descripcion,
        linkVideo: clase.linkVideo != null && clase.linkVideo != '' ? clase.linkVideo.replace('https://youtu.be/', '') : ''
      })

      if(clase.linkVideo != null && clase.linkVideo != '') this.updateVideoDetails()
        clase.musculos.forEach((valor, index) => {
          this.formClase.patchValue({ [`musculo${index + 1}`]: valor });
      });
      clase.linksAdicionales.forEach((valor, index) => {
        this.formClase.patchValue({ [`linkAdicional${index + 1}`]: valor });
      });
      if(clase.imagen) this.previewUrl = clase.imagen.url;

        let claseTags: any = []
        if(clase.tags){
            claseTags = clase.tags
        }
        this.arrTags = claseTags
  
      this.modalClase();
    }

    getClases(){
        const filters: any = {
            // "documentContainerId": this.userInfo.documentContainerId,
            // "empresaId": this.userInfo.empresaId,
            "activo": true
        };
        // GET FILTERS ARRAY
        let filtersQuery: any = this.documentService.getFiltersArray(filters);
        
        if(this.filtroTipo != '') {
            filtersQuery.push({
            "match_phrase": {
                "tipo.keyword": this.filtroTipo
            }
            });
        }
        if(this.filtroNivel != '') {
            filtersQuery.push({
            "match_phrase": {
                "nivel.keyword": this.filtroNivel
            }
            });
        }
        let should: any = []
        switch (this.filtroPropietario){
        case 'todos':
            should = [
            {
                "match_phrase": {
                "documentContainerId.keyword": this.userInfo.documentContainerId
                }
            },
            {
                "match_phrase": {
                "documentContainerId.keyword": environment.empresaBaseId
                }
            }
            ]
            break;
        case 'empresaBase':
            should = [
            {
                "match_phrase": {
                "documentContainerId.keyword": environment.empresaBaseId
                }
            }
            ]
            break;
        case 'propios':
            should = [
            {
                "match_phrase": {
                "documentContainerId.keyword": this.userInfo.documentContainerId
                }
            }
            ]
            break;
        }
        filtersQuery.push({"bool": { should }})
        const query = {
            "sort": [
                {
                    "esDocumentDate": {
                        "order": "desc",
                        "unmapped_type": "boolean"
                    }
                }
            ],
            "size": 200,
            "query": {
                "bool": {
                    "must": [],
                    "filter": filtersQuery,
                    "should": [],
                    "must_not": []
                }
            }
        };
        setTimeout(() => {
            this.documentService.searchDocument(environment.businessId, this.pattern, query).subscribe({
                next: (data: any) => {
                    console.log(data)
                    this.listaClases = [];
                    this.listaClasesFiltradas = [];
                    this.listaClases = [...data];
                    this.listaClasesFiltradas = [...data];
                },
                error: (error: any) => {
                    console.error(error);
                    this.listaClases = [];
                }
            });
        }, 1500);
    }

    createOrUpdateClaseFn(){
        this.submitFormClases = true;
        if(this.formClase.invalid)
        {
            Swal.fire('Advertencia', 'Verifica que los campos sean válidos.', 'warning');
            return;
        }

        let linksAdicionalesArray = []
        if(this.formClase.get('linkAdicional1').value) linksAdicionalesArray.push(this.formClase.get('linkAdicional1').value);
        if(this.formClase.get('linkAdicional2').value) linksAdicionalesArray.push(this.formClase.get('linkAdicional2').value);
        if(this.formClase.get('linkAdicional3').value) linksAdicionalesArray.push(this.formClase.get('linkAdicional3').value);

        let musculosArray = []
        if(this.formClase.get('musculo1').value) musculosArray.push(this.formClase.get('musculo1').value);
        if(this.formClase.get('musculo2').value) musculosArray.push(this.formClase.get('musculo2').value);
        if(this.formClase.get('musculo3').value) musculosArray.push(this.formClase.get('musculo3').value);

        let claseDocModel: ClaseModel = {
            activo: true,
            nombre: this.formClase.get('nombre').value,
            tipo: this.formClase.get('tipo').value,
            nivel: this.formClase.get('nivel').value,
            equipo: this.formClase.get('equipo').value,
            musculos: musculosArray,
            descripcion: this.formClase.get('descripcion').value,
            duracion: this.formClase.get('duracion').value,
            // imagen: null,
            linkVideo: 'https://youtu.be/'+this.formClase.get('linkVideo').value,
            linksAdicionales: linksAdicionalesArray,
            propietario: this.userInfo.documentContainerId,
            empresaId: this.userInfo.empresaId,
            tags: this.arrTags
        };
        console.log(claseDocModel)

        if(this.croppedImage!='' && this.rawFile!=null)
        {
            let croppedImage = this.croppedImage.replace(/^data:.+;base64,/, '');
            let name = this.rawFile.name;
            let type = this.rawFile.type;
            this.uploadService.uploadImage(environment.businessId, this.utilsService.create_UUID(), name, croppedImage, type).subscribe({
                next: (fileData: any) => {
                    claseDocModel.imagen = { nombre: this.rawFile.name, url: fileData.fileName }
                    if(this.editarClase) this.updateClaseFn(claseDocModel, this.editarClase.documentId);
                    if(!this.editarClase) this.createClaseFn(claseDocModel);
                },
                error: (error) => {
                    console.error(error)
                }
            })
        } else {
            if(this.previewUrl == null) claseDocModel.imagen = null;
            if(this.editarClase) this.updateClaseFn(claseDocModel, this.editarClase.documentId);
            if(!this.editarClase) this.createClaseFn(claseDocModel);
        }
    }
    createClaseFn(claseDocModel) {
        this.documentService.createDocumentInContainer(
            environment.businessId,
            this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
            null,
            this.pattern,
            null,
            claseDocModel,
        ).subscribe({
            next: (data) => {
                // debugger
                console.log(data);
                this.submitFormClases = false;
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Ejercicio guardado con éxito",
                    showConfirmButton: false,
                    timer: 1500
                });
                $("#modal-clase").modal('hide');
                // this.getClases();
                this.consultaClasesTags()
                this.inicializarFormClase();
            },
            error: (error) => {
                console.error(error);
                //this.loading = false;
            },
        });
    }
    updateClaseFn(claseDocModel: ClaseModel, documentId) {
        let title = ''
        if(claseDocModel.activo) title = "Ejercicio actualizado con éxito";
        if(!claseDocModel.activo) title = "Ejercicio eliminado con éxito";

        this.documentService.updateDocumentInContainer(
            environment.businessId,
            this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
            documentId,
            this.pattern,
            null,
            claseDocModel
        ).subscribe({
            next: (data) => {
                console.log(data);
                this.submitFormClases = false;
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: title,
                    showConfirmButton: false,
                    timer: 1500
                });
                if(claseDocModel.activo) $("#modal-clase").modal('hide');
                this.getClases();
                this.inicializarFormClase();
            },
            error: (error) => {
                console.error(error);
            },
        });
    }
    deleteClaseFn(claseDocModel) {
        Swal.fire({
            title: 'Eliminar clase',
            html: '¿Seguro que desea eliminar el clase: <b>"'+claseDocModel.nombre+'"</b>?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar'
        }).then((result) => {
            if (result.isConfirmed) {
                claseDocModel.activo = false;
                this.updateClaseFn(claseDocModel, claseDocModel.documentId)
            }
        })
    }
    inicializarFormClase(){
        this.editarClase = false;
        this.deleteImage();
        this.arrTags = []
        this.videoUrl = null;
        this.formClase.setValue({
            nombre: '',
            tipo: '',
            nivel: '',
            duracion: '',
            equipo: '',
            musculo1: '',
            musculo2: '',
            musculo3: '',
            descripcion: '',
            linkVideo: '',
            linkAdicional1: '',
            linkAdicional2: '',
            linkAdicional3: '',
        })
    }

    get formClaseControl()
    {
        return this.formClase.controls;
    }

    /******************* IMÁGENES ********************/
    // Propiedades para Image Cropper
    imageChangedEvent: any = '';
    croppedImage: string = '';
    bolCroppedImg: boolean = false;
    rawFile: any;

    // Previsualización de las imágenes
    previewUrl: string | null = null;

    fileChangeEvent(event: any, ): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
        const file = input.files[0];
        const reader = new FileReader();
        reader.onload = () => {
            this.imageChangedEvent = event;
            this.bolCroppedImg = true;
            this.rawFile = {
            file: reader.result,
            type: file?.type,
            name: file?.name
            };
        };
        reader.readAsBinaryString(file);
        }
    }

    imageCropped(event: ImageCroppedEvent, ) {
        console.log("imageCropped()", event.base64)
        this.croppedImage = event.base64 || '';
        // this.previewUrlInicial = this.croppedImageInicial;
    }

    imageLoaded() {
        console.log(`Image loaded`);
    }

    cropperReady(event: any, ) {
        console.log(`Cropper ready`, event);
    }

    loadImageFailed() {
        console.error(`Failed to load image`);
        this.deleteImage();
    }

    deleteImage() {
        this.imageChangedEvent = '';
        this.croppedImage = '';
        this.bolCroppedImg = false;
        this.previewUrl = null;
        this.rawFile = null;
    }


    // VIDEO
    videoUrl: SafeResourceUrl | null = null;
    updateVideoDetails() {
        const link = 'https://youtu.be/'+this.formClase.get('linkVideo')?.value;
        if (link) {
            const videoId = this.extractVideoId(link);
            if (videoId) {
                this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                    `https://www.youtube.com/embed/${videoId}`
                );
            } else {
                this.videoUrl = null; // Limpia la URL si no es válida
            }
        }
    }

    private extractVideoId(url: string): string | null {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = url.match(regex);
        return match ? match[1] : null;
    }

    modalTagsFn(){
        $('.clase>input[type=checkbox]').each(function() {
            $(this).attr('checked', false);
        })

        let arr = this.arrTags
        $('.clase>input[type=checkbox]').each(function() {
            let currentValue = this.value;  // or +this.value or other conversion
            if (arr.indexOf(currentValue) !== -1) {
                $(this).attr('checked', 'checked');
            }
        })
        $('#modal-tags-clases').modal('show');
    }

    onCheckboxEquipmentChange(e: any) {
        console.log(e.target.checked)
        console.log(e.target.value)

        if(e.target.checked){
            this.arrTags.push(e.target.value);
        }else{
            let i: number = 0;
            this.arrTags.forEach((item: any) => {
                if (item == e.target.value) {
                    this.arrTags.splice(i, 1);
                    return;
                }
                i++;
            });
        }

        console.log('arr tags', this.arrTags)
    }

    openModalTagsSearch(){
        $("#modal-tags-clases-search").modal("show")
    }

    onCheckboxTagsSearchChange(e: any) {
        this.arrTagsFilter = []
        if(e.target.checked){
            this.arrTagsSearch.push(e.target.value);
        }else{
            let i: number = 0;
            this.arrTagsSearch.forEach((item: any) => {
                if (item == e.target.value) {
                    this.arrTagsSearch.splice(i, 1);
                    return;
                }
                i++;
            });
        }

        let arrQuery: any = []
        let obj: any = {};

        for(let j in this.arrTagsSearch){
            let match_phrase: any = {}
            match_phrase['tags.keyword'] = this.arrTagsSearch[j]
            obj.match_phrase = match_phrase
            this.arrTagsFilter.push(obj)
        }

        console.log(this.arrTagsFilter)

    }

    consultaClasesTags(){
        let bool: any = {}
        let bool2: any = {}
        let should: any = []
        let should2: any = []

        should = this.arrTagsFilter
        bool.should = should

        switch (this.filtroPropietario){
            case 'todos':
                should2.push({
                    "match_phrase": {
                      "documentContainerId.keyword": this.userInfo.documentContainerId
                    }
                },
                {
                    "match_phrase": {
                    "documentContainerId.keyword": environment.empresaBaseId
                    }
                })
                break;
            case 'empresaBase':
                should2.push({
                    "match_phrase": {
                    "documentContainerId.keyword": environment.empresaBaseId
                    }
                })
                break;
            case 'propios':
                should2.push({
                    "match_phrase": {
                    "documentContainerId.keyword": this.userInfo.documentContainerId
                    }
                })
                break;
        }
        bool2.should = should2

        const query = {
            "sort": [
                {
                    "esDocumentDate": {
                        "order": "desc",
                        "unmapped_type": "boolean"
                    }
                }
            ],
            "size": 200,
            "query": {
                "bool": {
                    "must": [],
                    "filter": [{ "bool": bool}, { "bool": bool2}],
                    "should": [],
                    "must_not": []
                }
            }
        };

        this.documentService.searchDocument(
            environment.businessId,
            this.pattern,
            query
        ).subscribe({
            next: (data) => {
                console.log(data)
                this.listaClases = [];
                this.listaClasesFiltradas = [];
                this.listaClases = [...data];
                this.listaClasesFiltradas = [...data];
                this.filtrarPorNombre({target: {value: this.filtroNombreTemp}});
                $("#modal-tags-search").modal("hide")
            },
            error: (error) => {
                console.error(error);
            },
        });
    }

    // Agregar método de filtrado
    filtrarPorNombre(event: any) {
        const valor = event.target.value.toLowerCase().trim();
        this.filtroNombreTemp = valor;
        
        // Si no hay valor, mostrar todas las clases
        if (!valor) {
            this.listaClasesFiltradas = this.listaClases;
            return;
        }
        // Filtrar la lista actual
        this.listaClasesFiltradas = this.listaClases.filter(clase =>
            clase.nombre.toLowerCase().includes(valor)
        );
    }
}
